import { Core } from "@faire/design-tokens";
import { optimizeProductImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import React from "react";
import styled from "styled-components";

interface IProps {
  selectedBrandOrder?: ISelfServeBrandOrder;
}

const NUMBER_OF_IMAGES_TO_SHOW = 3;

export const OrderSummaryCardImages: React.FC<IProps> = ({
  selectedBrandOrder,
}) => {
  const orderItems = selectedBrandOrder?.brand_order?.order_items;
  const images = orderItems
    ?.map((orderItem) => ({
      order_item_token: orderItem.token,
      ...orderItem?.product_image,
    }))
    .filter(isNotUndefined);

  if (!images) {
    return null;
  }

  if (images.length <= 3) {
    return (
      <>
        {images.map((image, index) => {
          if (!image) {
            return null;
          }
          return (
            <Row key={image.order_item_token}>
              {index !== 0 ? <Spacer width="1x" /> : null}
              <ProductImage src={optimizeProductImageUrl(image, false, 60)} />
            </Row>
          );
        })}
      </>
    );
  }

  //If there are more than 3 images, we only want to show the first 3 with an overlay of #images not shown
  return (
    <>
      {images.map((image, index) => {
        if (!image || index >= NUMBER_OF_IMAGES_TO_SHOW) {
          return null;
        }

        return (
          <Row key={image.order_item_token}>
            {index !== 0 ? <Spacer width="1x" /> : null}
            {index === NUMBER_OF_IMAGES_TO_SHOW - 1 && images ? (
              <ImageWrapper>
                <Overlay>
                  <Typography
                    variant="paragraphSansMedium"
                    color={Core.text.inverse}
                  >{`+${
                    images?.length - NUMBER_OF_IMAGES_TO_SHOW
                  }`}</Typography>
                </Overlay>
                <ProductImage src={optimizeProductImageUrl(image, false, 60)} />
              </ImageWrapper>
            ) : (
              <ProductImage src={optimizeProductImageUrl(image, false, 60)} />
            )}
          </Row>
        );
      })}
    </>
  );
};

const ProductImage = styled.img`
  height: 60px;
  width: 60px;
`;

const Overlay = styled(Column).attrs({ align: "center", justify: "center" })`
  position: absolute;
  background-color: ${Core.surface.default};
  opacity: 0.7;
  height: 60px;
  width: 60px;
`;

const ImageWrapper = styled.div`
  position: relative;
`;
